import React from 'react';

const MyWork = () => {
    return <div className="container-fluid" />;
};

export default MyWork;
